// extracted by mini-css-extract-plugin
module.exports = {"icon-button":"IconButton_icon-button__2r-ww","__text":"IconButton___text__3SfnZ"};